// extracted by mini-css-extract-plugin
export default {"card":"Card_card__QZXb6","card_dark":"Card_card_dark__Wp+o8"};